const conversationIds = new Map<string, string>();

function keyOf(shopId: string, creatorOpenId: string) {
  return `${shopId}\n${creatorOpenId}`;
}

/** 记下创建会话接口返回的平台 conversation_id，后续发私信必须用它。 */
export function rememberDmConversation(shopId: string, creatorOpenId: string, conversationId: string) {
  const shop = shopId.trim();
  const creator = creatorOpenId.trim();
  const conversation = conversationId.trim();
  if (!shop || !creator || !conversation) return;
  conversationIds.set(keyOf(shop, creator), conversation);
}

export function getDmConversationId(shopId: string, creatorOpenId: string) {
  return conversationIds.get(keyOf(shopId.trim(), creatorOpenId.trim()));
}
